import SignupForm from '../forms/SignupForm';
import { useChangePasswordURLParams } from '../forms/auth/newPasswordCommon';
import NonLoggedPage from '../templates/NonLoggedPage';

export default function SignupPage() {
  const { token, email } = useChangePasswordURLParams();

  return (
    <NonLoggedPage logoutUser centered>
      <SignupForm token={token} email={email} />
    </NonLoggedPage>
  );
}
